import React from 'react';
import { firestoreConnect } from 'react-redux-firebase';
import { compose } from 'redux';
import WeeklyMission from './WeeklyMission';

function WeeklyMissionsList({ missions }) {
  return (
    <div className="company-list section">
      <div className="title-section">Weekly missions</div>
      {missions.map((mission) => {
        return <WeeklyMission key={mission.id} mission={mission} />;
      })}
    </div>
  );
}

export default compose(firestoreConnect())(WeeklyMissionsList);
